export const IconsList = {
    flags: ['us', 'sa', 'fr', 'in', 'ph', 'pk']
}
